var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"tab-header"},[_vm._v(" Wypłaty ")]),_c('grid',{attrs:{"source":_vm.gridDataSource,"name":_vm.gridName,"columns":_vm.gridColumns,"actions":_vm.gridActions,"additional-params":_vm.getAdditionalParams},on:{"show":_vm.actionShow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }